import React from 'react';
import Loading from '../../../../../components/Loading';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { desktopMinWidth } from '../../../../../../utils/windowHelpers';
import colors from '../../../../../constants/colors';

const LoadingSubmissionScreen = ({
  label = 'Just a moment for us to load up some stats...',
}) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      label: {
        fontSize: 16,
        marginTop: '-8px',
        color: colors.black_33,
        textAlign: 'center',
        [desktopMinWidth]: {
          fontSize: 16,
        },
      },
    }),
  );

  const classes = useStyles();

  return (
    <div>
      <Loading />
      <div className={classes.label}>{label}</div>
    </div>
  );
};

export default LoadingSubmissionScreen;
